import React, { FC } from "react";

import { cutString } from "shared/lib/stringFormat";
import { SpecialOfferParameters, SpecialOfferType } from "shared/types";

import Img from "@components/FileServer/Img";

const LOCATION_MAX_LENGTH = 24;

const BestOfferItinerary: FC<{
  offerParameters?: SpecialOfferParameters;
}> = ({ offerParameters }) => {
  if (
    !offerParameters ||
    !offerParameters.destination ||
    !offerParameters.origin
  ) {
    return null;
  }

  return (
    <div className="best-offer-itinerary">
      <span
        className="best-offer-itinerary__origin"
        title={offerParameters.origin}
      >
        {cutString(offerParameters.origin, LOCATION_MAX_LENGTH)}
      </span>
      {!!offerParameters?.type && (
        <div className="best-offer-itinerary__type">
          <FlightTypeIcon type={offerParameters.type} />
        </div>
      )}
      <span
        className="best-offer-itinerary__destination"
        title={offerParameters.destination}
      >
        {cutString(offerParameters.destination, LOCATION_MAX_LENGTH)}
      </span>
    </div>
  );
};

const FlightTypeIcon: React.FC<{ type: SpecialOfferType }> = ({ type }) => {
  switch (type) {
    case "multicity":
      return (
        <Img
          src="/static/images/ico-plane-double.svg"
          className="best-offer-itinerary__type-icon"
          height={15}
          width={36}
          alt="multicity flight plane icon"
          title={type}
        />
      );
    case "oneway":
      return (
        <Img
          src="/static/images/ico-plane-oneway.svg"
          className="best-offer-itinerary__type-icon"
          height={15}
          width={29}
          alt="oneway flight plane icon"
          title={type}
        />
      );
    case "return":
      return (
        <Img
          src="/static/images/ico-plane-back.svg"
          className="best-offer-itinerary__type-icon"
          height={22}
          width={22}
          alt="return flight plane icon"
          title={type}
        />
      );
    default:
      return null;
  }
};

export default BestOfferItinerary;
